import React from 'react';
import ReactDOM from 'react-dom';
import DuplicateResolutionModal from './DuplicateResolutionModal';

// Expose components to window for use in ERB views
window.React = React;
window.ReactDOM = ReactDOM;
window.DuplicateResolutionModal = DuplicateResolutionModal;
